import { render, staticRenderFns } from "./SinMenuConAlertas.vue?vue&type=template&id=794dca1b&scoped=true"
import script from "./SinMenuConAlertas.vue?vue&type=script&lang=js"
export * from "./SinMenuConAlertas.vue?vue&type=script&lang=js"
import style0 from "./SinMenuConAlertas.vue?vue&type=style&index=0&id=794dca1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794dca1b",
  null
  
)

export default component.exports